<template>
  <v-row>
    <v-col cols="12" md="6">
      <div id="base-ware-name">
        <v-autocomplete
            clearable
            v-model="model"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            :return-object="false"
            :disabled="disabled"
            class="rounded-lg"
            item-text="name"
            item-value="id"
            :label="`نام عمومی ${title}`"
            placeholder="ورود حداقل سه حرف از نام برای پیدا کردن لازم است"
            append-icon="fa-search"
        ></v-autocomplete>
      </div>
    </v-col>
    <v-col cols="12" md="6">
      <div id="base-ware-type">
        <v-autocomplete
            :label="`نوع ${title}`"
            v-model="model"
            :items="items"
            item-text="get_type"
            class="rounded-lg"
            item-value="id"
            :disabled="true"
        >
        </v-autocomplete>
      </div>
    </v-col>
    <v-col cols="12" md="6">
      <div id="base-ware-code">
        <v-autocomplete
            :label="`شناسه عمومی ${title}`"
            v-model="model"
            :items="items"
            item-text="code"
            class="rounded-lg"
            item-value="id"
            :disabled="true"
        >
        </v-autocomplete>
      </div>
    </v-col>
    <v-col cols="12" md="6">
      <div id="base-ware-value-add-tax">
        <v-autocomplete
            :label="`نرخ مالیات ارزش افزوده ${title}`"
            v-model="model"
            :items="items"
            item-text="value_added_tax"
            class="rounded-lg"
            item-value="id"
            :disabled="true"
        >
        </v-autocomplete>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "CleaveBaseWare",
  props: {
    isService: {
      type: Boolean,
      default: false,
    },
    disabled: {
      default: false,
    },
    first_item: null,
  },

  data: () => ({
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
  }),
  updated() {
    if (this.first_item) {
      this.model = this.first_item
      console.log(this.model)
      this.request({
        url: this.endpoint("wares/baseWare/" + this.first_item + '/'),
        method: "get",
        success: data => {
          this.search = data['title']
        }
      });
    }
  },
  computed: {
      title() {
        if (this.isService) {
          return "خدمت ";
        } else {
          return "کالا";
        }
      },
      fields() {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a',
        }
      })
    },
    items() {
      return this.entries.map(entry => {
        const Description = entry.length > this.descriptionLimit
            ? entry.slice(0, this.descriptionLimit) + '...'
            : entry.Description

        return Object.assign({}, entry, {Description})
      })
    },
  },

  watch: {
    search(val) {
      if (val.length > 2) {
        // Items have already been loaded
        if (this.items.length > 0) return

        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        // Lazily load input items
        this.request({
          url: this.endpoint(`wares/baseWareSearch/${this.isService?'service':'ware'}/` + val + '/'),
          method: "get",
          success: data => {
            this.count = data.length
            this.entries = data
            this.isLoading = false
          }
        });
      } else if (val.length < 3) {
        this.entries = []
      }

    },
    model() {
      console.log('test')
      this.$emit("input", this.model);
    }

  },
  }
</script>
